export default __webpack_public_path__ + "media/images/icons/app-4-65c35ca2f1fae6c0eabf1fa84a58fce1.png";